module.exports = __webpack_public_path__ + "static/media/flautanovo.aee910a1.mp4";